import * as ng from 'angular';
import { StorageService } from '../../../services/storage.service';
import { UserService } from '../../../services/user.service';

class UploadLogoModalController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$sce',
        'StorageService',
        '$rootScope',
        'UserService',
        'store'
    ];

    private close: any;
    private dismiss: any;

    constructor(
        private $scope: any,
        private $sce: ng.ISCEService,
        private _storageService: StorageService,
        private $rootScope: any,
        private _userService: UserService,
        private store: ng.a0.storage.IStoreService
    ) {
        let logoBefore = '';

        let vm: any = this;

        vm.user = $scope.$parent.$resolve.user;
        vm.save = save;
        vm.cancel = cancel;
        vm.deleteFile = deleteFile;
        vm.logoIsEmpty = logoIsEmpty;
        vm.updateLogo = updateLogo;
        vm.loading = false;
        vm.logoFilename = '';

        function save() {
            vm.updateLogo();
        }

        function cancel() {
            vm.user.organizationData.logoStoragePath = logoBefore;
            this.dismiss();
        }


        let init = () => {
            vm.user.organizationData.logoStoragePath = vm.user.organizationData.logoStoragePath === undefined ||
                vm.user.organizationData.logoStoragePath === '' ?
                'Allega logo' : vm.user.organizationData.logoStoragePath;

            logoBefore = vm.user.organizationData.logoStoragePath === 'Allega logo' ? '' : vm.user.organizationData.logoStoragePath;

            if (vm.user.organizationData.logoStoragePath !== 'Allega logo') {
                vm.logoFilename = extractFilename(vm.user.organizationData.logoStoragePath);
            }

            if (!logoIsEmpty()) {
                getLogoBase64(vm.user.organizationData.logoStoragePath);
            }
        };

        init();

        $scope.uploadFileOnGoogleStorageCallback = (dropzoneId, res, filename) => {
            let icon = '';
            let extension = filename.split('.').pop().toLowerCase();
            let delete_icon = '<a ng-click=\'vm.deleteFile($event)\'><i class=\'fa fa-trash-o fa-lg\'></i></a>';

            switch (extension) {
                case 'jpg':
                case 'png':
                    icon = $sce.trustAsHtml('<i class=\'fa fa-file-image-o fa-lg\'></i>');
                    break;
                default:
                    icon = $sce.trustAsHtml('<i class=\'fa fa-file-o fa-lg\'></i>');
            }

            vm.user.organizationData.logoStoragePath = res.id.split('/')[0] + '/' + res.name;
            vm.logoFilename = filename;
            vm.icon = icon;
            vm.delete_icon = delete_icon;

            getLogoBase64(vm.user.organizationData.logoStoragePath);
        };

        function deleteFile($event: any) {
            vm.user.organizationData.logoStoragePath = 'Allega logo';
            vm.icon = '';
            vm.delete_icon = '';
        }

        function logoIsEmpty() {
            return vm.user.organizationData.logoStoragePath === '' || vm.user.organizationData.logoStoragePath === undefined
                || vm.user.organizationData.logoStoragePath === 'Allega logo';
        }

        function updateLogo() {
            if (logoIsEmpty() || logoBefore === vm.user.organizationData.logoStoragePath) {
                return;
            }

            vm.loading = true;

            let promise = _userService.updateLogo(vm.user)
                .then((response) => {
                    vm.user = $scope.$parent.$resolve.user;
                    store.set('user', vm.user);
                    this.close({ $value: vm.user });
                }, (error) => {
                    $rootScope.alert('error', error);
                    vm.loading = false;
                });
            return promise;
        }

        function getLogoBase64(logoStoragePath: any) {
            _storageService.getBase64(logoStoragePath)
                .then((response) => {
                    vm.imagePreview = response;
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        }

        function extractFilename(logoPath: any) {
            let path = logoPath.split('/');
            return path[path.length - 1];
        }
    }
}

export const UploadLogoModalComponent: ng.IComponentOptions = {
    template: require('./upload-logo-modal.html'),
    controller: UploadLogoModalController,
    bindings: {
        close: '&',
        dismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/upload-logo-modal/upload-logo-modal.ts